var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmployeesLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.62 27.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0c0c0c;}.cls-2{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.81,
    cy: 13.81,
    r: 12.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20,18.06l-6.22-.78-6.23.78a3.48,3.48,0,0,0-3,3.45v1a12.72,12.72,0,0,0,18.54,0v-1A3.49,3.49,0,0,0,20,18.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.44,11.49c0,3.2-2.07,5.79-4.63,5.79s-4.64-2.59-4.64-5.79,2.08-4.63,4.64-4.63A4.27,4.27,0,0,1,18.44,11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.81,18.35c-3.14,0-5.7-3.08-5.7-6.86a5.34,5.34,0,0,1,5.7-5.7,5.34,5.34,0,0,1,5.7,5.7C19.51,15.27,17,18.35,13.81,18.35Zm0-10.43a3.23,3.23,0,0,0-3.57,3.57c0,2.61,1.6,4.73,3.57,4.73s3.57-2.12,3.57-4.73A3.23,3.23,0,0,0,13.81,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.81,27.62a13.71,13.71,0,0,1-10-4.35,1.09,1.09,0,0,1-.28-.73v-1a4.53,4.53,0,0,1,4-4.5l6.23-.78a1.13,1.13,0,0,1,.26,0l6.22.78h0a4.54,4.54,0,0,1,4,4.5v1a1.05,1.05,0,0,1-.29.73A13.69,13.69,0,0,1,13.81,27.62ZM5.6,22.11a11.66,11.66,0,0,0,16.42,0v-.6a2.42,2.42,0,0,0-2.12-2.39l-6.09-.77-6.09.77A2.42,2.42,0,0,0,5.6,21.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.81,27.62A13.81,13.81,0,1,1,27.62,13.81,13.83,13.83,0,0,1,13.81,27.62Zm0-25.5A11.69,11.69,0,1,0,25.49,13.81,11.71,11.71,0,0,0,13.81,2.12Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesLight);
export default __webpack_public_path__ + "static/media/employees_light.3531c142c32145ff69afa3b55cb159e0.svg";
export { ForwardRef as ReactComponent };